export default __webpack_public_path__ + "static/highlight-2-mobile-76cb02c5f8d9248d5ca74639ae5b5814.svg";